interface ProgressBarProps {
  value: number
  max?: number
  label?: string
}

export function ProgressBar({ value, max = 100, label }: ProgressBarProps) {
  const percent = Math.max(0, Math.min(100, (value / max) * 100))
  return (
    <div className="w-full" aria-label={label} role="progressbar" aria-valuemin={0} aria-valuemax={max} aria-valuenow={value}>
      {label && <div className="mb-2 text-sm font-bold text-garden-800">{label}</div>}
      <div className="h-3 overflow-hidden rounded-full bg-garden-100">
        <div className="h-full rounded-full bg-garden-500 transition-all duration-500" style={{ width: `${percent}%` }} />
      </div>
    </div>
  )
}
